<section class="animated fadeIn">
    <div class="breadcrumbArea">
        <div class="container">
            <div class="row justify-content-between align-items-center">
                <div class="col">
                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink="/approval"> <i class="hdr-home"></i> </a></li>
                            <li class="breadcrumb-item active">Report</li>
                        </ol>
                    </nav>
                </div>
                <div class="col text-right">  
                   <a class="mar-rt-24" > <i class="hdr-exportexcel filterIcon" [hidden]="exporttoexceldisable" tooltip="Export to Excel" container="body" placement="left" (click)="exporttoexcel()"></i></a>
                   <a (click)="visibleSidebar2 = true" class="" > <i class="hdr-filter filterIcon" tooltip="Filter" container="body" placement="bottom"></i></a>
                </div>
            </div>
        </div>
    </div>
    

    <div class="mt20">
        <div class="container">
            <div class="rows">
                <div class=" table reqTbl">
                    <p-table
                    [value]="delegationData"
                    [paginator]="true"
                    [rows]="5"
                    [showCurrentPageReport]="true"
                    [tableStyle]="{ 'min-width': '50rem' }"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    (onPage)="pageChange($event)"
                    [rowsPerPageOptions]="[5, 10, 25, 50]"
                    [value]="delegationData" (sortFunction)="customSort($event)" [customSort]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="Del_ReqId">Request ID <p-sortIcon field="Del_ReqId"></p-sortIcon></th>
                            <th pSortableColumn="RequesterName">Delegator /SAP ID <p-sortIcon field="RequesterName"></p-sortIcon></th>
                            <th pSortableColumn="DelegateeName">Delegatee /SAP ID <p-sortIcon field="DelegateeName"></p-sortIcon></th>
                            <th pSortableColumn="AppName">Application Name <p-sortIcon field="AppName"></p-sortIcon></th>
                            <th pSortableColumn="RoleName">Role <p-sortIcon field="RoleName"></p-sortIcon></th>
                            <th pSortableColumn="SubRoleName">Sub-Role <p-sortIcon field="SubRoleName"></p-sortIcon></th>
                            <th pSortableColumn="DelegationStartDate">Duration <p-sortIcon field="DelegationStartDate"></p-sortIcon></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-delegation>
                        <tr>
                            <td>{{delegation.Del_ReqId}}</td>
                            <td>{{delegation.RequesterName|titlecase}}({{delegation.RequesterSAPId}})</td>
                            <td>{{delegation.DelegateeName|titlecase}}({{delegation.DelegateeSAPId}})</td>
                            <td>{{delegation.AppName}}</td>
                            <td>{{delegation.RoleName}}</td>
                            <td>{{delegation.SubRoleName}}</td>
                            <td>{{delegation.DelegationStartDate  | date: 'dd-MMM-yy'}} to {{delegation.DelegationEndDatetime | date: 'dd-MMM-yy' }}</td>
                        </tr>
                    </ng-template>
                </p-table>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- Filter -->
<p-sidebar class="filter" [(visible)]="visibleSidebar2" position="right" [style]="{width:'340px'}">
    <div class="filter-body">
        <h3> Filter 
            <button class="close" aria-label="close filter" (click)="visibleSidebar2 = false">
                <i class="icon-cancel"></i>
            </button> 
        </h3>
        <div class="FormField">
            <label>Delegatee/SAP ID</label>
            <div class="posRel FormField2">
                <p-autoComplete [(ngModel)]="delegateeTextvalue" [suggestions]="filteredBrands" (completeMethod)="filterBrands($event)" [size]="30" [minLength]="1" 
                placeholder="Search By Name or User ID" panelStyleClass="panelClass" (onKeyUp)="textValue($event)" (onSelect)="updateDelegateeId($event)"></p-autoComplete>
                <i class="icon-search"></i>
              </div>
        </div>
        <div class="FormField">
            <label>Application</label>
            <p-dropdown placeholder="Search" [options]="AppsFilter" [(ngModel)]="AppFilterData" (onChange)="getRolebyApplication()"></p-dropdown>
        </div>
        <div class="FormField">
            <label>Role</label>
            <p-dropdown placeholder="Search" [options]="RolesFilter" [(ngModel)]="RoleNameValue"></p-dropdown>
        </div>
        <div class="FormField">
            <label>Status</label>
            <p-dropdown placeholder="Search" [options]="StatusFilter" [(ngModel)]="RequestStatus"></p-dropdown>
        </div>
        <div class="text-center glb-btn mt-16">
            <button class="btn secondry-button" (click) = "ClearData()">Reset</button>
            <button class="btn primary-button" (click)="getDataofFiltersValues()">Apply</button>
            <!-- <button class="btn primary-button" (click)="visibleSidebar2 = false">Apply</button> -->
        </div>

    </div>
</p-sidebar>

<!-- alertTemp for Dowload Excel-->
<ng-template #downloadExcel>
    <div class="mtable">
        <div class="mCell">
            <h4 (click)="modalRef.hide()" class="closeS"></h4>
            <span class="alertIcon"> <i class="hdr-attention"></i> </span>
            <h3>Don't have access to download</h3>
            <div class="glb-btn mt-48 glb-btn">
                <button (click)="modalRef.hide()" class="btn primary-button">OK</button>              
            </div>
        </div>
    </div>
  </ng-template>

  <!-- alertTemp for Filter -->
<ng-template #alertfilter>
    <div class="mtable">
        <div class="mCell">
            <h4 (click)="modalRef.hide()" class="closeS"></h4>
            <span class="alertIcon"> <i class="hdr-attention"></i> </span>
            <h3>Please enter/select value in any filter option</h3>
            <div class="glb-btn mt-48 glb-btn">
                <button (click)="modalRef.hide()" class="btn primary-button">OK</button>              
            </div>
        </div>
    </div>
</ng-template>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
  